"use client";
import { usePathname } from "next/navigation";
import Footer from "./Footer/Footer";

export default function ConditionalFooter() {
  const pathname = usePathname();
  if (pathname.startsWith("/admin")) return null;
  return <Footer />;
} 